module.exports = __webpack_public_path__ + "img/RentersBtn.cbce97cf.svg";